const UserIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9103 16.238C11.9612 16.7917 13.165 17.1058 14.4444 17.1058C15.5513 17.1058 16.6015 16.8707 17.5449 16.4492L17.7995 16.3296C20.8633 17.7072 23 20.8148 23 24.4276V25H5.5V24.4276C5.5 20.8132 7.63852 17.7045 10.7046 16.3273L10.9103 16.238ZM10.9309 18.3213L10.8458 18.3691C9.16951 19.335 7.96644 20.973 7.53824 22.8777L7.48949 23.1104H21.0094L21.0085 23.1028C20.6392 21.165 19.4724 19.4799 17.8115 18.4631L17.7241 18.4113L17.4841 18.4971C16.6129 18.7923 15.6959 18.9598 14.7579 18.9903L14.4444 18.9954C13.3058 18.9954 12.1944 18.7939 11.1537 18.4079L10.9309 18.3213ZM14.6667 3C17.9656 3 20.64 5.70724 20.64 9.04678C20.64 12.3233 18.0656 14.9912 14.8527 15.0907L14.6667 15.0936C11.3677 15.0936 8.69333 12.3863 8.69333 9.04678C8.69333 5.77025 11.2677 3.10238 14.4806 3.00288L14.6667 3ZM14.6667 4.88962C12.3986 4.88962 10.56 6.75085 10.56 9.04678C10.56 11.3427 12.3986 13.2039 14.6667 13.2039C16.9347 13.2039 18.7733 11.3427 18.7733 9.04678C18.7733 6.75085 16.9347 4.88962 14.6667 4.88962Z"
            fill="url(#paint0_linear_5552_52178)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5552_52178"
                x1="2.79354"
                y1="21.9625"
                x2="30.2209"
                y2="9.70059"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF6666" />
                <stop offset="1" stopColor="#FFF35C" />
            </linearGradient>
        </defs>
    </svg>
)

export default UserIcon
